import script from "./AppResumed.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppResumed.vue?vue&type=script&setup=true&lang=ts"

import "./AppResumed.vue?vue&type=style&index=0&id=70dde968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70dde968"]])

export default __exports__